import React, { forwardRef } from 'react';
import ReactInputMask, {
  BeforeMaskedStateChangeStates,
  InputState,
} from 'react-input-mask';

interface CurrencyProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef?: React.Ref<HTMLInputElement>;
  beforeMaskedStateChange?(states: BeforeMaskedStateChangeStates): InputState;
}

const BankInputMask = forwardRef<ReactInputMask, CurrencyProps>(
  ({ inputRef, beforeMaskedStateChange, value, ...props }, ref) => {
    return (
      <ReactInputMask
        mask="99999 99999 99999999999 99"
        alwaysShowMask={false}
        maskPlaceholder=""
        value={value || ''}
        maskChar={null}
        beforeMaskedStateChange={beforeMaskedStateChange}
        ref={ref}
        inputRef={inputRef}
        {...props}
      >
        {(inputProps: any) => <input {...inputProps} />}
      </ReactInputMask>
    );
  },
);

BankInputMask.displayName = 'BankInputMask';

export default BankInputMask;
